<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    id?: string;
    header?: string;
    headerTag?: 'div' | 'h5' | 'h6' | 'strong' | 'span';
    divider?: boolean;
    padded?: boolean;
  }>(),
  {
    headerTag: 'strong',
    divider: false,
    padded: false,
  },
);

const sectionAttrs = computed(() => {
  const attrs: Record<string, any> = {};
  if (props.id) {
    attrs.id = props.id;
  }
  if (props.header && props.id) {
    attrs['aria-labelledby'] = `${props.id}__header`;
  }
  return attrs;
});

const headerId = computed(() => (props.id ? `${props.id}__header` : undefined));
</script>

<template>
  <section v-bind="sectionAttrs" class="itp-form-section">
    <div
      v-if="header || $slots['header-toolbar']"
      class="mb-2 d-flex align-items-center gap-2 justify-content-between"
    >
      <component :is="headerTag" v-if="header" :id="headerId" class="mb-0">
        {{ header }}
      </component>

      <div class="ms-auto d-inline-flex align-items-center">
        <slot name="header-toolbar" />
      </div>
    </div>

    <hr v-if="divider" class="mt-0 mb-3" />

    <div :class="padded ? 'p-2' : ''">
      <slot />
    </div>
  </section>
</template>

